import { BookingflowStateMachine } from '@raskrask-dk/bookingflow-state-machine'
import { useEffect } from 'react'
import { stateNotifier } from './services/stateNotifier'
import ReactPixel from 'react-facebook-pixel'

export const useTracking = (BFSM: BookingflowStateMachine): void => {
    useEffect(() => {
        BFSM.attach(
            stateNotifier([
                {
                    stateName: 'ADDRESS',
                    action: () => ReactPixel.track('ViewContent'),
                },
                {
                    stateName: 'BASISTYPE',
                    action: () => ReactPixel.track('CustomizeProduct'),
                },
                {
                    stateName: 'CALENDAR',
                    action: () => ReactPixel.track('AddToCart'),
                },
                {
                    stateName: 'DETAILS',
                    action: () => ReactPixel.track('InitiateCheckout'),
                },
            ])
        )

        return () => BFSM.detach('EXTRAFUNC')
    }, [BFSM])
}
